<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增班次"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="form.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="isUsing" label="是否启用">
          <mu-radio :value="true" v-model="form.isUsing" label="是"></mu-radio>
          <mu-radio :value="false" v-model="form.isUsing" label="否"></mu-radio>
        </mu-form-item>

        <mu-form-item prop="isOvertime" label="是否加班">
          <mu-radio
            :value="true"
            v-model="form.isOvertime"
            label="是"
          ></mu-radio>
          <mu-radio
            :value="false"
            v-model="form.isOvertime"
            label="否"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="startTime" label="上班时间">
          <mu-text-field
            v-model="form.startTime"
            placeholder="格式：HH:MM或HH:MM:SS"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="endTime" label="下班时间">
          <mu-text-field
            v-model="form.endTime"
            placeholder="格式：HH:MM或HH:MM:SS"
          ></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        isUsing: true,
        isOvertime: false,
        startTime: '',
        endTime: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.schedule.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                name: '',
                isUsing: true,
                isOvertime: false,
                startTime: '',
                endTime: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/schedule/create.vue